<template>
  <div>

    <div class="bouttonCustom" :class="[model, taille]" >
      <div>
        <img
          :src="'interface/'+picto"
          :alt="label"
        >
        </div>
      <h5 v-if="taille === 'normal'" v-html="label"></h5>     
      <h3 v-if="taille === 'big'" v-html="label"></h3>     
    </div>

    
  </div>
</template>

<script>
export default {
  name: 'btActions',
  props: {
    model: { type: String, required: true },
    label: { type: String, required: true },
    picto: { type: String, default: '' },
    taille: { type: String, default: 'normal' },
  },
  computed: {
  },
  methods: {
   
  }
};
</script>

<style scoped>

.bouttonCustom {
  cursor: pointer;
  width: auto;
}
.left{
    display: flex;
    flex-direction: row;
    text-align: left;
    align-items: center;
}
.left img{
    padding-right: 10px;
}
.center{
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
}

.normal img{
    height: 30px;
}
.big img{
    height: 40px;
}

</style>